import { render, staticRenderFns } from "./MediaAttribute.vue?vue&type=template&id=bb0d555e"
import script from "./MediaAttribute.vue?vue&type=script&lang=js"
export * from "./MediaAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports